module.exports = __webpack_public_path__ + "img/type--2-spans--multiple-lang--de.191b3fcf.jpg";